/* global THREE */
import aframe from "aframe";
import { bindEvent } from "aframe-event-decorators";

const rand = () => (Math.random() - 0.5) * 2;

aframe.registerComponent("explosion-spawner", {
  schema: {
    interval: { type: "number", default: 500 },
    enabled: { default: false }
  },
  init: function () {
    this._debugPlane = new THREE.Mesh(
      new THREE.BoxGeometry(2, 2, 2, 4),
      new THREE.MeshBasicMaterial({
        color: "blue",
        side: THREE.DoubleSide,
        wireframe: true
      })
    );
    this._debugPlane.rotation.x = Math.PI / 2;
    this._debugPlane.visible = false;
    this.el.object3D.add(this._debugPlane);
    this.timer = this.data.interval;
    this.poolEl = document.querySelector("[mipool__explosion]");
  },
  play: function () {
    this._gameState = document.querySelector("[game-state]").components[
      "game-state"
    ];
  },
  tick(t, dt) {
    if (!this.data.enabled) {
      return;
    }

    this.timer += dt;
    if (this.timer >= this.data.interval) {
      this.spawnExplosion();
      this.timer -= this.data.interval;
    }
  },
  spawnExplosion: (() => {
    const v1 = new THREE.Vector3();
    const v2 = new THREE.Vector3();

    return function () {
      const position = v1
        .set(
          rand() * this.el.object3D.scale.x,
          rand() * this.el.object3D.scale.y,
          rand() * this.el.object3D.scale.z
        )
        .add(this.el.object3D.getWorldPosition(v2));

      const silo = getNearestSiloTo(position);
      if (silo !== undefined) {
        silo.components["missile-silo"].fireAt(position);
      }
    };
  })(),
  inspectorenabled: bindEvent({ target: "a-scene" }, function () {
    this._debugPlane.visible = true;
  }),
  inspectordisabled: bindEvent({ target: "a-scene" }, function () {
    this._debugPlane.visible = false;
  }),
  gamestatechanged: bindEvent({ target: "[game-state]" }, function (evt) {
    const newState = evt.detail;
    if (newState === "Playing") {
      this.el.setAttribute("paused", false);
    } else {
      this.el.setAttribute("paused", true);
    }
  })
});

const getNearestSiloTo = (() => {
  // const v1 = new THREE.Vector3();
  const v2 = new THREE.Vector3();

  return function (p) {
    const missileSilos = document.querySelectorAll(".missile-silo");
    let nearest = undefined;
    let nearestDistance = -1;
    missileSilos.forEach(silo => {
      if (!silo.components["missile-silo"].canFire()) {
        return;
      }
      const d = p.distanceTo(silo.object3D.getWorldPosition(v2));
      if (nearest === undefined || d < nearestDistance) {
        nearest = silo;
        nearestDistance = d;
      }
    });
    return nearest;
  };
})();
